<style lang="scss" scoped>
.coupon {
  display: flex;

  flex-flow: row nowrap;

  .coupon-left {
    position: relative;

    width: 1.88rem /* 94/50 */;
    height: 1.26rem /* 63/50 */;
    padding: 0.2rem /* 10/50 */;

    background-image: linear-gradient(45deg, #ff7a62 0%, #fd6b64 100%);
    border-radius: 0.12rem /* 6/50 */ 0.16rem /* 8/50 */ 0.16rem /* 8/50 */
      0.12rem /* 6/50 */;

    flex: none;

    &:after {
      display: block;

      position: absolute;
      top: 0.32rem /* 16/50 */;
      right: 0;

      width: 1px;
      height: 0.64rem /* 32/50 */;

      border-right: 1px dashed #fff;

      opacity: 0.4;

      content: '';
    }

    .price {
      color: #fff;

      .symbol {
        font-size: 0.24rem /* 12/50 */;
      }

      .value {
        font-size: 0.52rem /* 26/50 */;
      }
    }

    .rule {
      font-size: 0.24rem /* 12/50 */;
      color: #fff;
    }
  }
  .coupon-right {
    width: 1.44rem /* 72/50 */;
    height: 1.26rem /* 63/50 */;
    padding: 0.2rem /* 10/50 */;

    background-image: linear-gradient(45deg, #fd6b64 0%, #ff6060 100%);
    border-radius: 0.16rem /* 8/50 */ 0.12rem /* 6/50 */ 0.12rem /* 6/50 */
      0.16rem /* 8/50 */;

    .title {
      margin: 0.04rem /* 2/50 */ auto;

      font-size: 0.28rem /* 14/50 */;
      text-align: center;
      color: #fff;
    }

    .button {
      display: flex;

      width: 1.08rem /* 54/50 */;
      height: 0.3rem /* 15/50 */;
      margin-top: 0.2rem /* 10/50 */;
      padding: 0;

      background-color: #fff;
      border-radius: 0.16rem /* 8/50 */;

      justify-content: center;
      align-items: center;

      font-size: 0.2rem /* 10/50 */;
      line-height: 0.3rem /* 15/50 */;
      text-align: center;
      color: #ff6260;

      flex-flow: row nowrap;

      span {
        flex: none;

        text-align: center;
      }
    }
  }

  &.claim {
    .coupon-left,
    .coupon-right {
      background-color: #d8d8d8;
      background-image: none;

      .button {
        span {
          color: #686868;
        }
      }
    }
  }
}
</style>

<template>
  <div
    :class="{
      coupon: true,
      claim: claim
    }"
  >
    <div class="coupon-left">
      <p class="price">
        <span class="symbol">￥</span>
        <span class="value">{{ value }}</span>
      </p>
      <p class="rule">{{ rule }}</p>
    </div>
    <div class="coupon-right">
      <p class="title">{{ title }}</p>
      <div class="button" @click.prevent="claimHandler">
        <span>{{ claim ? '已领取' : '点击领取' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    rule: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '优惠券'
    },
    claim: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    claimHandler() {
      if (!this.claim) {
        this.$emit('claim')
      }
    }
  }
}
</script>
